import { combineReducers } from 'redux'
import {
  ANIMAL_TYPE_PAGE_ERROR, ANIMAL_TYPE_PAGE_LOADING, ANIMAL_TYPE_LIST_SUCCESS,
  ANIMAL_TYPE_VIEW_SUCCESS, ANIMAL_TYPE_PAGE_SUCCESS, ANIMAL_TYPE_VIEW_ERROR,
  ANIMAL_TYPE_ADD_ERROR, ANIMAL_TYPE_ADD_LOADING, ANIMAL_TYPE_ADD_SUCCESS,
  ANIMAL_TYPE_VIEW_LOADING, ANIMAL_TYPE_DELETE_ERROR, ANIMAL_TYPE_DELETE_LOADING, 
  ANIMAL_TYPE_DELETE_SUCCESS, ANIMAL_TYPE_UPDATE_SUCCESS, ANIMAL_TYPE_UPDATE_ERROR, 
  ANIMAL_TYPE_UPDATE_LOADING, ANIMAL_TYPE_LIST_ERROR, ANIMAL_TYPE_LIST_LOADING, ANIMAL_TYPE_BOOKING_ERROR, ANIMAL_TYPE_BOOKING_LOADING, ANIMAL_TYPE_BOOKING_SUCCESS
} from './constant'

const animalTypePageError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_PAGE_ERROR:
      return action.animalTypePageError
    default:
      return state
  }
}

const animalTypePageLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_PAGE_LOADING:
      return action.animalTypePageLoading
    default:
      return state
  }
}

const animalTypePageSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_PAGE_SUCCESS:
      return action.animalTypePageSuccess
    default:
      return state
  }
}

const animalTypes = (state = [], action) => {
  switch (action.type) {
    case ANIMAL_TYPE_PAGE_SUCCESS:
      return action.animalType
    case ANIMAL_TYPE_LIST_SUCCESS:
      return action.animalType
    case ANIMAL_TYPE_BOOKING_SUCCESS:
      return action.animalType
    default:
      return state
  }
}

const animalType = (state = [], action) => {
  switch (action.type) {
    case ANIMAL_TYPE_VIEW_SUCCESS:
      return action.animalType
    default:
      return state
  }
}

const animalTypeAddError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_ADD_ERROR:
      return action.animalTypeAddError
    default:
      return state
  }
}

const animalTypeAddLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_ADD_LOADING:
      return action.animalTypeAddLoading
    default:
      return state
  }
}

const animalTypeAddSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_ADD_SUCCESS:
      return action.animalTypeAddSuccess
    default:
      return state
  }
}

const animalTypeViewError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_VIEW_ERROR:
      return action.animalTypeViewError
    default:
      return state
  }
}

const animalTypeViewLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_VIEW_LOADING:
      return action.animalTypeViewLoading
    default:
      return state
  }
}

const animalTypeViewSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_VIEW_SUCCESS:
      return action.animalTypeViewSuccess
    default:
      return state
  }
}

const animalTypeDeleteError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_DELETE_ERROR:
      return action.animalTypeDeleteError
    default:
      return state
  }
}

const animalTypeDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_DELETE_LOADING:
      return action.animalTypeDeleteLoading
    default:
      return state
  }
}

const animalTypeDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_DELETE_SUCCESS:
      return action.animalTypeDeleteSuccess
    default:
      return state
  }
}

const animalTypeUpdateError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_UPDATE_ERROR:
      return action.animalTypeUpdateError
    default:
      return state
  }
}

const animalTypeUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_UPDATE_LOADING:
      return action.animalTypeUpdateLoading
    default:
      return state
  }
}

const animalTypeUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_UPDATE_SUCCESS:
      return action.animalTypeUpdateSuccess
    default:
      return state
  }
}

const animalTypeListError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_LIST_ERROR:
      return action.animalTypeListError
    default:
      return state
  }
}

const animalTypeListLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_LIST_LOADING:
      return action.animalTypeListLoading
    default:
      return state
  }
}

const animalTypeListSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_LIST_SUCCESS:
      return action.animalTypeListSuccess
    default:
      return state
  }
}

const animalTypeBookingError = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_BOOKING_ERROR:
      return action.animalTypeBookingError
    default:
      return state
  }
}

const animalTypeBookingLoading = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_BOOKING_LOADING:
      return action.animalTypeBookingLoading
    default:
      return state
  }
}

const animalTypeBookingSuccess = (state = false, action) => {
  switch (action.type) {
    case ANIMAL_TYPE_BOOKING_SUCCESS:
      return action.animalTypeBookingSuccess
    default:
      return state
  }
}

const animalTypeReducer = combineReducers({
  animalTypePageError,
  animalTypePageLoading,
  animalTypePageSuccess,

  animalTypes,
  animalType,

  animalTypeAddError,
  animalTypeAddLoading,
  animalTypeAddSuccess,

  animalTypeViewError,
  animalTypeViewLoading,
  animalTypeViewSuccess,

  animalTypeDeleteError,
  animalTypeDeleteLoading,
  animalTypeDeleteSuccess,

  animalTypeUpdateError,
  animalTypeUpdateLoading,
  animalTypeUpdateSuccess,

  animalTypeListError,
  animalTypeListLoading,
  animalTypeListSuccess,

  animalTypeBookingError,
  animalTypeBookingLoading,
  animalTypeBookingSuccess,
})

export default animalTypeReducer
